(function () {
  var KEY = 'mn_b2b_lead';
  var form = document.getElementById('anfrage-form');

  // Produktbereiche (Mehrfachauswahl) in ein Feld zusammenfassen und Eckdaten für das Lead-Event merken
  if (form) {
    form.addEventListener('submit', function () {
      var areas = [].map.call(form.querySelectorAll('input[data-area]:checked'), function (i) { return i.value; });
      var hidden = form.querySelector('input[name="contact[Produktbereich]"]');
      if (hidden) hidden.value = areas.join(', ');
      try {
        var b = form.querySelector('select[name="contact[Branche]"]');
        var q = form.querySelector('input[name="contact[Geschätzte Stückzahl]"]');
        sessionStorage.setItem(KEY + '_data', JSON.stringify({
          branche: b ? b.value : '',
          produktbereich: areas.join(', '),
          stueckzahl: q ? q.value : ''
        }));
      } catch (e) {}
    });
  }

  // Nach erfolgreichem Absenden: zur Bestätigung scrollen und Lead-Event genau einmal melden
  var done = document.querySelector('[data-b2b-done]');
  if (!done) return;
  done.scrollIntoView({ block: 'center' });

  try { if (sessionStorage.getItem(KEY + '_sent')) return; } catch (e) {}

  var data = {};
  try { data = JSON.parse(sessionStorage.getItem(KEY + '_data') || '{}'); } catch (e) {}
  var payload = {
    event_id: 'b2b-' + Date.now() + '-' + Math.random().toString(36).slice(2, 8),
    form: 'b2b_anfrage',
    branche: data.branche || '',
    produktbereich: data.produktbereich || '',
    stueckzahl: data.stueckzahl || ''
  };

  var tries = 0;
  var timer = setInterval(function () {
    tries++;
    var a = window.Shopify && window.Shopify.analytics;
    if (a && typeof a.publish === 'function') {
      clearInterval(timer);
      a.publish('b2b_lead', payload);
      try { sessionStorage.setItem(KEY + '_sent', '1'); } catch (e) {}
    } else if (tries > 40) {
      clearInterval(timer);
    }
  }, 250);
})();
